module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-Regular.3b41f92c.woff";